<p-breadcrumb
  [model]="[
    { label: 'Regras de Avaliação', routerLink: ['/assessment-rules'] },
    {
      label: assessmentRuleId() ? 'Editar Regra' : 'Nova Regra',
      routerLink: assessmentRuleId()
        ? ['/assessment-rules/update/' + assessmentRuleId()]
        : ['/assessment-rules/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if(assessmentRuleId()){
        <h5 class="font-bold">Editar Regra de Avaliação</h5>
        <p>Confira e atualize informações</p>
        } @else {
        <h5 class="font-bold">Cadastrar Nova Regra de Avaliação</h5>
        <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>

      <div class="flex justify-end gap-5 items-center">
        @if(assessmentRuleId()){
        <div class="w-full flex items-center gap-1">
          <label for="isActive"> Status: </label><br />
          <div class="flex gap-2 items-center">
            <p-toggleswitch formControlName="isActive"></p-toggleswitch>
            {{ formGroup.get("isActive")!.value ? "Ativo" : "Inativo" }}
          </div>
        </div>
        }

        <div class="flex gap-2">
          <p-button
            label="Cancelar"
            routerLink="/assessment-rules"
            severity="secondary"
            rounded
            class="btn-secondary-outline"
          >
          </p-button>
          <p-button type="submit" label="Salvar" rounded></p-button>
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="card space-y-5 w-full">
    <h5 class="font-bold">Informações gerais</h5>

    <div class="flex flex-wrap xl:flex-nowrap gap-5">
      <div class="w-full">
        <label for="name">Nome *</label>
        <input
          pInputText
          type="text"
          formControlName="name"
          class="w-full"
          placeholder="Informe o nome"
        />
        <app-form-error [control]="formGroup.get('name')" />
        <app-form-server-error [control]="formGroup.get('name')" />
      </div>

      <div class="w-full">
        <label for="assessmentId">Avaliação *</label>
        <p-select
          formControlName="assessmentId"
          [options]="assessmentsDropdown()"
          [loading]="assessmentSelectLoading()"
          optionLabel="label"
          [filter]="true"
          filterBy="label"
          placeholder="Selecione a avaliação"
          class="w-full"
        >
        </p-select>
        <app-form-error [control]="formGroup.get('assessmentId')" />
        <app-form-server-error [control]="formGroup.get('assessmentId')" />
      </div>
    </div>

    <div class="w-full">
      <label for="condition">Condição *</label>
      <input
        pInputText
        type="text"
        formControlName="condition"
        class="w-full"
        placeholder="Descreva a condição para que o critério seja atendido"
      />
      <app-form-error [control]="formGroup.get('condition')" />
      <app-form-server-error [control]="formGroup.get('condition')" />
    </div>

    <div class="w-full">
      <label for="failureMessage">Mensagem de falha *</label>
      <input
        pInputText
        type="text"
        formControlName="failureMessage"
        class="w-full"
        placeholder="Informe uma mensagem de falha"
      />
      <app-form-error [control]="formGroup.get('failureMessage')" />
      <app-form-server-error [control]="formGroup.get('failureMessage')" />
    </div>
  </div>

  @if(loading()){
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading" />
  </div>
  }
</form>

<p-toast />
